import * as analytics from 'analytics/Analytics';
import APIUtil from 'util/APIUtil';

interface EntryAnalyticsInfo {
  entry_id: string;
  project_id: string;
}

interface TemplateAnalyticsInfo {
  template_id: string;
  template_collection_id: string;
}

export interface FileAnalyticsParams {
  fileId?: string | null;
  projectId?: string | null;
  templateCollectionId?: string | null;
}

/**
 * This function helps inject the analytics metadata for a notebook document tracking event.
 *
 * It will include `entry_id` and `project_id` for entries, and `template_id` and `template_collection_id`
 * for templates.
 */
export function getFileAnalyticsMetadata(
  params: FileAnalyticsParams | null
): EntryAnalyticsInfo | TemplateAnalyticsInfo | null {
  if (params?.fileId == null) {
    return null;
  }
  const {fileId, projectId, templateCollectionId} = params;
  if (APIUtil.isEntryTemplate(fileId)) {
    return {template_id: fileId, template_collection_id: templateCollectionId} as TemplateAnalyticsInfo;
  }
  return {entry_id: fileId, project_id: projectId} as EntryAnalyticsInfo;
}

export enum AttachedExternalFileAddedVia {
  DragAndDrop = 'drag_and_drop',
  InsertAttachment = 'insert_attachment',
  TFI = 'tfi',
}

export function trackAttachedExternalFile(
  fileId: string,
  addedVia: AttachedExternalFileAddedVia,
  fileType?: string,
  fileSizeBytes?: number,
  fileName?: string
): void {
  analytics.track('lab_notebook', 'attached_external_file', {
    file_id: fileId,
    added_via: addedVia,
    file_mime_type: fileType?.toLowerCase(),
    file_size_bytes: fileSizeBytes,
    // Note: choosing not to track complete file name for data privacy reasons; extension gives us additional metadata over file_mime_type
    file_extension: fileName && fileName.includes('.') ? fileName.split('.').pop()?.toLowerCase() : undefined,
  });
}
